import { render, staticRenderFns } from "./TraineeList.vue?vue&type=template&id=b44de180"
import script from "./TraineeList.vue?vue&type=script&lang=js"
export * from "./TraineeList.vue?vue&type=script&lang=js"
import style0 from "./TraineeList.vue?vue&type=style&index=0&id=b44de180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports